var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResources = function SvgResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M48 16H22a6 6 0 0 0-6 6v34a6 6 0 0 0 6 6h26a6 6 0 0 0 6-6V22a6 6 0 0 0-6-6m-26-2a8 8 0 0 0-8 8v34a8 8 0 0 0 8 8h26a8 8 0 0 0 8-8V22a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M26 26a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H27a1 1 0 0 1-1-1M26 34a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H27a1 1 0 0 1-1-1M26 42a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H27a1 1 0 0 1-1-1M32 68h22a8 8 0 0 0 8-8V28h-2v32a6 6 0 0 1-6 6H32zM58 18a1 1 0 0 1 1-1h2v-2a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgResources;